import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Reports } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchReportSummary = (reportId) => Reports.getSummary(reportId);
const useReportSummary = (reportId, refetchPeriodically = false) => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["reports", "summary", reportId],
    queryFn: () => defaultOnError(
      fetchReportSummary(reportId),
      i18n.t("notifications.fetch_report_failed", { ns: "enterprise_report" }),
      i18n.t("notifications.fetch_report_failed_title", { ns: "enterprise_report" })
    ),
    placeholderData: keepPreviousData,
    refetchInterval: refetchPeriodically ? 2e3 : void 0
  });
  return {
    data,
    isInitialLoading
  };
};
export default useReportSummary;
